var $primary, $primaryInputs, $catalogRequestForm;

$(window).on('js-onload', function(){

    // interest selection
    $primary = $('#primary-interest-selection:first');

    if($primary.length > 0) {
        $primaryInputs = $primary.find(':input');

        $('#opt-in').on('change', ':radio', function(){
            if($(this).val() == 'N') {
                $primary.addClass('hide');
                $primaryInputs.disable();
            } else {
                $primary.removeClass('hide');
                $primaryInputs.enable();
            }
        });

        $('#opt-in').find(':radio:checked:first').trigger('change');
    }

    // recaptcha submit
    $catalogRequestForm = $('#catalog_request_form');
    if($catalogRequestForm.length > 0) {

        $catalogRequestForm.validateRecaptcha();
            // .on('submit', submitCatalogRequest);

    }
});

window.catalogRequestRecaptcha = function() {
    $('.g-recaptcha + .parsley-errors-list').remove();
};

function submitCatalogRequest(event){
    var $form = $(this);
    var $btn = $form.find('button[type="submit"]:last');
    $btn.disable().addClass('loading');

    if(!$form.data('validated')) {
        event.preventDefault();

        var data = $form.find(':input:not([name="_token"])').serialize();

        $.get('/pages/catalog/check-customer', data, null, 'json')
            .fail(function(xhr){
                console.log(xhr);
            })
            .always(function(){
                $btn.enable().removeClass('loading');
            })
            .done(function(response){
                if(response.matches !== undefined) {

                    var modalContent = "<p>If any of the items below match your information, please select the item and click 'Yes'. Otherwise, click 'No'.</p>";
                    modalContent += Handlebars.templates['verify_customer']({
                        matches: response.matches
                    });

                    var markup = Handlebars.templates['modal']({
                        disableClose: true,
                        modalId: 'customerMatchModal',
                        header: {
                            title: 'Is this you?',
                        },
                        content: modalContent,
                        actions: [{
                            label: 'Yes',
                            class: 'button button-blue yes'
                        },
                        {
                            label: 'No',
                            class: 'button button-subtle no'
                        }]
                    });

                    $('body').append(markup);

                    $('#customerMatchModal')
                        .on('hidden.bs.modal', function(){
                            $(this).off('click').remove();
                        })
                        .on('shown.bs.modal', function(){
                            $(this).on('click', 'button', function(event){
                                var $modal = $(event.delegateTarget);
                                var $btns = $modal.find('button');
                                $btns.disable();

                                var val = $(event.target).hasClass('yes')
                                    ? $('[name="match"]:checked').val()
                                    : 'nomatch';

                                $btn.disable().addClass('loading');
                                $form.append(
                                    '<input type="hidden" name="matched" value="'+val+'">'
                                ).data('validated', true).submit();

                                $modal.modal('hide');
                            });
                        })
                        .modal({keyboard: false, backdrop: 'static'});

                    return;
                }

                $form.append(
                    '<input type="hidden" name="matched" value="nomatch">'
                ).data('validated', true).submit();
            });
    }
}